module.exports = __webpack_public_path__ + "assets/img/HomeInfo_header.8ab46bc2.jpg";